import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { IconColor, IconSize } from '@freelancer/ui/icon';

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-user-profile-editable-ui-action-row-redesign',
  template: `
    <div
      class="ActionRow"
      [class.IsNew]="!showDeleteButton"
      [flTrackingSection]="'ActionRow' + flTrackingSection"
    >
      @if (showDeleteButton && !showConfirmDeleteButton) {
        <fl-button
          class="ToggleDeleteButton Button mr-small"
          flTrackingLabel="DeleteResumeItemToggleButton"
          [busy]="isBusy"
          [color]="isStickyFooter ? ButtonColor.TEXT_RED : ButtonColor.CUSTOM"
          [size]="ButtonSize.MID"
          (click)="confirmDeletion()"
        >
          <fl-icon
            class="DeleteIcon mr-xxsmall"
            flTrackingLabel="DeleteToggleButton"
            [color]="IconColor.INHERIT"
            [name]="'ui-bin'"
            [size]="IconSize.MID"
            [useIconFont]="true"
          ></fl-icon>
          {{ deleteButtonText }}
        </fl-button>
      }

      @if (!showConfirmDeleteButton) {
        <fl-button
          class="Button"
          i18n="Save action button"
          flTrackingLabel="SaveAction"
          [busy]="isBusy"
          [color]="ButtonColor.PRIMARY"
          [size]="ButtonSize.MID"
          (click)="save.emit()"
        >
          Save
        </fl-button>
      }

      @if (showConfirmDeleteButton) {
        <fl-button
          class="CancelDeleteButton Button mr-small"
          i18n="Cancel Resume Item Delete"
          flTrackingLabel="CancelButtonClick"
          [color]="isStickyFooter ? ButtonColor.TEXT_DARK : ButtonColor.CUSTOM"
          [size]="ButtonSize.MID"
          (click)="handleBackClicked()"
        >
          Cancel
        </fl-button>
      }
      @if (showConfirmDeleteButton) {
        <fl-button
          class="Button"
          i18n="Confirm Delete Resume Item"
          flTrackingLabel="ConfirmDeleteResumeItem"
          [color]="ButtonColor.DANGER"
          [size]="ButtonSize.MID"
          (click)="delete.emit()"
        >
          <fl-icon
            class="DeleteIcon mr-xxsmall"
            flTrackingLabel="DeleteConfirmButton"
            [color]="IconColor.LIGHT"
            [name]="'ui-bin'"
            [size]="IconSize.MID"
            [useIconFont]="true"
          ></fl-icon>
          Delete
        </fl-button>
      }
    </div>
  `,
  styleUrls: ['./user-profile-editable-ui-action-row-redesign.component.scss'],
})
export class UserProfileEditableUiActionRowRedesignComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  IconColor = IconColor;
  IconSize = IconSize;

  @Input() deleteButtonText: string;
  @Input() flTrackingSection: string;
  @Input() isBusy: boolean;
  @Input() isStickyFooter: boolean;
  @Input() showDeleteButton: boolean;

  @Output() delete = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  showConfirmDeleteButton = false;

  confirmDeletion(): void {
    this.showConfirmDeleteButton = true;
  }

  handleBackClicked(): void {
    this.showConfirmDeleteButton = false;
  }
}
